/* eslint-disable */
import global from './global-variables';
import $ from 'jquery';
import PL_utils from '../patterns/pl-utils.js';

const getParam = function(name) {
  return (new RegExp('[?&]' + name + '=([^&]*)').exec(location.search) || []).splice(1,1)[0];
};

const setCookie = function(name, value, settings) {
  document.cookie = name + '=' + value + ';'
    + (settings && settings.Expires ? ' Expires=' + settings.Expires + ';' : '')
    + (settings && settings.MaxAge ? ' Max-Age=' + settings.MaxAge + ';' : '')
    + ' Path=' + (settings && settings.Path || '/') + ';'
    + (settings && settings.Secure === false ? '' : (location.protocol == 'https:' ? ' Secure;' : ''))
    + ' SameSite=' + (settings && settings.SameSite || 'None') + ';';
};

const getCookie = function(name) {
  return (new RegExp('(?:^|; ?)' + name + '=([^;]*)').exec(document.cookie) || []).splice(1,1)[0];
};

const generateGuid = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const getAnonymousToken = function() {
  var cookie = getCookie('__klick_crm');
  var __klick_crm = cookie ? cookie.split('&').reduce((b, q) => {if (q) {b[q.split('=')[0].replace('au.', '')] = q.split('=')[1];} return b}, {}) : {};
  var token = __klick_crm[global.DATA_ORIGIN_CODE];

  if (!token) {
    token = generateGuid();
    cookie = (cookie ? cookie + '&' : '') + 'au.' + global.DATA_ORIGIN_CODE + '=' + token;
  }

  setCookie('__klick_crm', cookie, { MaxAge: 60*60*24*7 });
  return token;
};

const getSession = function() {
  const session = getCookie('user');
  if (!session) {
    return null;
  }

  return JSON.parse(atob(session));
};

const setSession = function(session) {
  setCookie('user', btoa(JSON.stringify(session)), { SameSite: 'Strict' });
};

const logoutSession = function() {
  setCookie('user', '', { Expires: 'Thu, 01 Jan 1970 00:00:00 GMT', SameSite: 'Strict' });
  setCookie('csrfToken', '', { Expires: 'Thu, 01 Jan 1970 00:00:00 GMT', SameSite: 'Strict' });
  setCookie('session', '', { Expires: 'Thu, 01 Jan 1970 00:00:00 GMT', SameSite: 'Strict' });
  return $.ajax(global.API_ENDPOINT() + '/user/logout', {
      dataType: 'json',
      method: 'POST',
      xhrFields: {
          withCredentials: true,
      }
  })
};

const renderGoogleMap = (lat, lng, containerId) => {
  const mapLatLng = new google.maps.LatLng(lat, lng);
  const mapOptions = {
    clickableIcons: false,
    disableDefaultUI: true,
    draggable: false,
    draggableCursor: 'default',
    zoom: 15,
    center: mapLatLng,
  };
  const map = new google.maps.Map(document.getElementById(containerId), mapOptions);
  const marker = new google.maps.Marker({
    clickable: false,
    draggable: false,
    position: mapLatLng,
  });
  marker.setMap(map);

  return { map, marker };
};

const enableGoogleMapDrag = (map, marker, callback) => {
  map.setOptions({
    zoomControl: true,
    draggable: true,
    draggableCursor: 'grab',
  });
  marker.setDraggable(true);

  // Add a listener that executes a callback function
  // Ie, takes the new coordinates and updates it in the DB listing
  if (callback) {
    marker.addListener('dragend', (event) => {
      callback(event.latLng);
    });
  }

  return { map, marker };
};

const disableGoogleMapDrag = (map, marker) => {
  map.setOptions({
    zoomControl: false,
    draggable: false,
    draggableCursor: 'default',
    zoom: 15,
    center: marker.getPosition(),
  });
  marker.setDraggable(false);
  google.maps.event.clearInstanceListeners(marker);

  return { map, marker };
};

const setButtonLoadingState = (button, spinner, state) => {
  if (state) {
      PL_utils.addClass("btn-loading", document.querySelector(button));
      PL_utils.removeClass("hidden", document.querySelector(spinner));
  } else {
      PL_utils.removeClass("btn-loading", document.querySelector(button));
      PL_utils.addClass("hidden", document.querySelector(spinner));
  }
};

const toLowercase = (s) => {
  return typeof s === 'string' ? s.toLowerCase() : s;
}

export default {
  getParam,
  getCookie,
  setCookie,
  getAnonymousToken,
  getSession,
  setSession,
  logoutSession,
  renderGoogleMap,
  enableGoogleMapDrag,
  disableGoogleMapDrag,
  setButtonLoadingState,
  toLowercase,
};
